import { api } from '@/services'

export function findAll(params) {
  return api.get('/web/charge/list', { params })
}

export function payCharge(paymentData) {
  return api.post('/web/charge/setChargePaymentMethod', paymentData)
}

export function generateReport(params) {
  return api.get('/web/charge/createReport', { params, responseType: 'arraybuffer' })
}